import {StringUtil} from './string';

export class ValidateUtil {

    public static isValidEmail(email: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    public static isValidName(name: string): boolean {
        if (name.length < 3) {
            return false;
        }

        return true;
    }

    public static isValidPhoneNumber(phoneNumber: string): boolean {
        phoneNumber = StringUtil.replaceAll(phoneNumber, ' ', '');

        if (!phoneNumber || phoneNumber.length < 1) {
            return false;
        }

        if ((phoneNumber as string).startsWith('+')) {
            phoneNumber = phoneNumber.substr(1, phoneNumber.length - 1);
        }
        if ((phoneNumber as string).includes('-')) {
            phoneNumber = StringUtil.replaceAll(phoneNumber, '-', '');
        }
        if ((phoneNumber as string).includes('(')) {
            phoneNumber = StringUtil.replaceAll(phoneNumber, '(', '');
        }
        if ((phoneNumber as string).includes(')')) {
            phoneNumber = StringUtil.replaceAll(phoneNumber, ')', '');
        }
        if (phoneNumber) {
            const regex = /[^\d^*]/;
            return !regex.test(phoneNumber);
        } else {
            return false;
        }
    }

    public static isValidUrl(url: string): boolean {
        const urlRe = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
        return urlRe.test(url);
    }

    public static isValidDomain(domain: string): boolean {
        const domainRe = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g;
        return domainRe.test(domain);
    }

    public static normalizeNumber(string: string): string {
        string = StringUtil.replaceAll(string, ' ', '');
        string = StringUtil.replaceAll(string, '+', '00');
        string = StringUtil.replaceAll(string, /[^\d^*]/, '');
        return string;
    }


    /*
        public static isValidPassword(password: string): boolean {
            if (!password || password.length === 0) {
                return false;
            }

            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
            return regex.test(password);
        }
    */

}
